var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var ImageCategories = function () {
            function ImageCategories(params) {
                _classCallCheck(this, ImageCategories);

                this.images = params.images ? params.images : [];
                this.rooms = params.rooms ? params.rooms : [];
                this.pageType = params.pageType ? params.pageType : null;

                this.hasAllCategory = false;
                this.hasAllRooms = false;

                this.roomsSwiper = null;
            }

            _createClass(ImageCategories, [{
                key: "setReviewPhotos",
                value: function setReviewPhotos(photos, label) {
                    if (!photos.length || this.images[34]) return;
                    this.images[34] = { id: 34, name: label, preview: photos[0].url };
                    var slide = document.createElement('div');
                    slide.className = 'category-item swiper-slide';
                    slide.dataset.id = '34';
                    var image = document.createElement('img');
                    image.className = 'category-photo';
                    image.src = photos[0].url;
                    image.alt = '';
                    var name = document.createElement('div');
                    name.className = 'category-name';
                    name.textContent = label;
                    slide.appendChild(image);
                    slide.appendChild(name);
                    var container = document.querySelector('#hotelPhotosCategories');
                    container.querySelector('.swiper-wrapper').appendChild(slide);
                    if (container.swiper) container.swiper.update();
                }
            }, {
                key: "renderCategories",
                value: function renderCategories() {
                    var swiper = this._createSwiper();

                    var categories = [];

                    for (var key in this.images) {
                        var category = this.images[key];

                        if (!this.hasAllCategory) {
                            categories.push(this._createSlide(0, 'Все', category.preview, 'active'));
                            this.hasAllCategory = true;
                        }

                        categories.push(this._createSlide(category.id, category.name, category.preview));
                    }

                    swiper.innerHTML = "<div class=\"swiper-wrapper\">" + categories.join('') + "</div>" + this._createControls();

                    return swiper;
                }
            }, {
                key: "_createSwiper",
                value: function _createSwiper() {
                    var content = document.createElement('div');
                    content.id = 'hotelPhotosCategories';
                    content.classList.add('swiper');

                    return content;
                }
            }, {
                key: "initSwiper",
                value: function initSwiper() {
                    var params = {
                        preloadImages: false,
                        lazy: {
                            loadPrevNext: true, // грузить соседние
                            loadPrevNextAmount: 1,
                            loadOnTransitionStart: true
                        },
                        watchSlidesProgress: true, // важно для lazy + 'auto'
                        observer: true,
                        observeParents: true,
                        freeMode: false,
                        loop: false,
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        slideToClickedSlide: true,
                        watchSlidesVisibility: true,
                        speed: 200,
                        pagination: {
                            el: ".swiper-pagination",
                            dynamicBullets: true
                        },
                        navigation: {
                            nextEl: '.category-next',
                            prevEl: '.category-prev'
                        }
                    };
                    new Swiper('#hotelPhotosCategories', params);

                    this.handlers();
                }
            }, {
                key: "_createControls",
                value: function _createControls() {
                    var btnPrev = '<button type="button"></button>';
                    var btnNext = '<button type="button"></button>';
                    var overlay = '<span class="overlay"></span>';
                    var controlPrev = "<div class=\"category-control category-prev\">" + btnPrev + overlay + "</div>";
                    var controlNext = "<div class=\"category-control category-next\">" + btnNext + overlay + "</div>";

                    return "" + controlPrev + controlNext;
                }
            }, {
                key: "_createSlide",
                value: function _createSlide(id, name, src) {
                    var cssClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

                    var categoryName = "<div class=\"category-name\">" + name + "</div>";
                    var img = "<div class=\"category-photo\" style=\"background-image: url(" + src + ")\"></div>";

                    return "<div class=\"category-item swiper-slide " + cssClass + "\" data-id=\"" + id + "\">" + img + categoryName + "</div>";
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    eventDispatcher.on('click', '#hotelPhotosCategories .category-item', function (event, element) {
                        if (element.classList.contains('active')) {
                            return;
                        }

                        QS('#hotelPhotosCategories .category-item.active').classList.remove('active');
                        element.classList.add('active');

                        var categoryId = element.dataset.id ? element.dataset.id : 0;

                        if (categoryId === '3') {
                            if (_this.roomsSwiper) {
                                _this._toggleRoomSwiper(true);
                            } else {
                                _this._initRoomsSwiper();
                            }
                        } else {
                            _this._toggleRoomSwiper(false);
                        }

                        if (event.isTrusted) {
                            var eventProperties = { Page: _this.pageType, category_id: String(categoryId),
                                category_key: String(categoryId) === '34' ? 'tourist_photos' : 'category_' + categoryId };
                            window.brxTracking.sendAnalyticsEvent('click_category_hotel_gallery', eventProperties);
                        }

                        eventDispatcher.dispatchEvent('filter-slides', {
                            categoryId: categoryId
                        });
                    });
                }
            }, {
                key: "_initRoomsSwiper",
                value: function _initRoomsSwiper() {
                    var self = this;
                    this._renderRoomsSwiper();
                    var params = {
                        preloadImages: false,
                        lazy: true,
                        freeMode: false,
                        loop: false,
                        slidesPerView: 'auto',
                        spaceBetween: 12,
                        watchSlidesProgress: true,
                        slideToClickedSlide: true,
                        speed: 200,
                        pagination: {
                            el: ".swiper-pagination",
                            dynamicBullets: true
                        },
                        navigation: {
                            nextEl: '.room-next button',
                            prevEl: '.room-prev button'
                        },
                        on: {
                            slideChange: function slideChange(swiper) {
                                self._changeSlide(swiper);

                                var eventProperties = { Page: this.pageType };
                                window.brxTracking.sendAnalyticsEvent('change_room_images', eventProperties);
                            }
                        }
                    };
                    this.roomsSwiper = new Swiper('#hotelPhotosRooms', params);
                }
            }, {
                key: "_renderRoomsSwiper",
                value: function _renderRoomsSwiper() {
                    var content = document.createElement('div');
                    content.id = 'hotelPhotosRooms';
                    content.classList.add('swiper');

                    var rooms = [];

                    for (var key in this.rooms) {
                        var room = this.rooms[key];

                        if (!this.hasAllRooms) {
                            rooms.push(this._createRoomSlide(0, 'Все', 'active'));
                            this.hasAllRooms = true;
                        }

                        rooms.push(this._createRoomSlide(key, room));
                    }

                    content.innerHTML = "<div class=\"swiper-wrapper\">" + rooms.join('') + "</div>" + this._createRoomControls();

                    QS('#hotelPhotosCategories').insertAdjacentElement('afterend', content);
                }
            }, {
                key: "_createRoomSlide",
                value: function _createRoomSlide(id, name) {
                    var cssClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

                    var roomName = "<div class=\"room-name\">" + name + "</div>";

                    return "<div class=\"room-item swiper-slide " + cssClass + "\" data-id=\"" + id + "\">" + roomName + "</div>";
                }
            }, {
                key: "_createRoomControls",
                value: function _createRoomControls() {
                    var btnPrev = '<button type="button"></button>';
                    var btnNext = '<button type="button"></button>';
                    var overlay = '<span class="overlay"></span>';
                    var roomControlPrev = "<div class=\"room-control room-prev\">" + btnPrev + overlay + "</div>";
                    var roomControlNext = "<div class=\"room-control room-next\">" + btnNext + overlay + "</div>";

                    return "" + roomControlPrev + roomControlNext;
                }
            }, {
                key: "_toggleRoomSwiper",
                value: function _toggleRoomSwiper(value) {
                    var element = QS('#hotelPhotosRooms');

                    if (element) {
                        element.style.display = value ? '' : 'none';
                    }
                }
            }, {
                key: "_changeSlide",
                value: function _changeSlide(swiper) {
                    var index = swiper.activeIndex; // текущий активный индекс
                    var slideEl = swiper.slides[index]; // DOM-элемент слайда

                    if (!slideEl) return;

                    var roomId = slideEl.dataset.id ? slideEl.dataset.id : 0;

                    eventDispatcher.dispatchEvent('filter-rooms', {
                        categoryId: '3',
                        roomId: roomId
                    });

                    if (index === 0) {
                        swiper.el.style.paddingLeft = '0';
                    } else {
                        swiper.el.style.paddingLeft = '52px';
                    }
                }
            }]);

            return ImageCategories;
        }();

        window.HotelImageGalleyCategories = ImageCategories;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */
        var MainSlider = function () {
            function MainSlider(params) {
                _classCallCheck(this, MainSlider);

                this.photosByCategories = params.photosByCategories ? params.photosByCategories : [];
                this.reviewsPhotos = params.reviewsPhotos ? params.reviewsPhotos : [];
                this.roomsPhotos = params.roomsPhotos ? params.roomsPhotos : [];
                this.pageType = params.pageType ? params.pageType : null;

                this.mainSwiper = null;
                this.thumbsSwiper = null;

                this.photos = [];
                this.previews = [];

                this.roomSlides = [];
                this.roomPreviewSlides = [];

                this._prepareImages();
            }

            _createClass(MainSlider, [{
                key: "setReviewPhotos",
                value: function setReviewPhotos(photos) {
                    var _this2 = this;

                    if (this.reviewPhotosLoaded) return;
                    this.reviewPhotosLoaded = true;
                    photos.forEach(function (photo, index) {
                        var image = document.createElement('img');
                        image.className = 'swiper-lazy';
                        image.dataset.src = photo.url;
                        image.alt = '';
                        var slide = '<div class="swiper-slide" data-category="34" data-review-id="' + photo.reviewId + '" data-photo-index="' + index + '">' + image.outerHTML + '<div class="swiper-lazy-preloader"></div></div>';
                        _this2.photos.push(slide);
                        _this2.previews.push(slide);
                    });
                    if (this.mainSwiper && photos.length) {
                        var activeCategory = QS('#hotelPhotosCategories .category-item.active');
                        if (activeCategory && activeCategory.dataset.id === '0') {
                            var index = this.mainSwiper.activeIndex;
                            this._buildSwipers(this.photos, this.previews);
                            this.mainSwiper.slideTo(index, 0);
                            this.thumbsSwiper.slideTo(index, 0);
                        }
                    }
                }
            }, {
                key: "render",
                value: function render() {
                    var content = document.createElement('div');
                    content.classList.add('sliders-wrapper');

                    content.appendChild(this._renderSwiper('main'));
                    content.appendChild(this._renderSwiper('thumbs'));

                    return content;
                }
            }, {
                key: "_prepareImages",
                value: function _prepareImages() {
                    var preloader = '<div class="swiper-lazy-preloader"></div>';
                    for (var key in this.photosByCategories) {
                        var photo = this.photosByCategories[key];
                        var img = "<img class=\"swiper-lazy\" data-src=\"" + photo.mainPath + photo.url + "\" alt=\"\">";
                        var preview = "<img class=\"swiper-lazy\" data-src=\"" + photo.previewPath + photo.url + "\" alt=\"\">";

                        if (key < 14) {
                            preview = "<img src=\"" + photo.previewPath + photo.url + "\" alt=\"\">";
                        }

                        if (key < 5) {
                            img = "<img src=\"" + photo.mainPath + photo.url + "\" alt=\"\">";
                        }

                        this.photos.push("<div class=\"swiper-slide\" data-category=\"" + photo.category + "\">" + img + preloader + "</div>");
                        this.previews.push("<div class=\"swiper-slide\" data-category=\"" + photo.category + "\">" + preview + preloader + "</div>");
                    }

                    for (var _key in this.reviewsPhotos) {
                        var _photo = this.reviewsPhotos[_key];
                        var _img = "<img class=\"swiper-lazy\" data-src=\"" + _photo.url + "\" alt=\"\">";
                        var _preview = "<img class=\"swiper-lazy\" data-src=\"" + _photo.url + "\" alt=\"\">";

                        this.photos.push("<div class=\"swiper-slide\" data-category=\"" + _photo.category + "\">" + _img + preloader + "</div>");
                        this.previews.push("<div class=\"swiper-slide\" data-category=\"" + _photo.category + "\">" + _preview + preloader + "</div>");
                    }

                    for (var _key2 in this.roomsPhotos) {
                        var item = this.roomsPhotos[_key2];
                        for (var itemKey in item.photos) {
                            var src = item.photos[itemKey];
                            var _img2 = "<img class=\"swiper-lazy\" data-src=\"" + src + "\" alt=\"\">";
                            var _preview2 = "<img class=\"swiper-lazy\" data-src=\"" + src + "\" alt=\"\">";

                            this.roomSlides.push("<div class=\"swiper-slide\" data-room-id=\"" + item.id + "\">" + _img2 + preloader + "</div>");
                            this.roomPreviewSlides.push("<div class=\"swiper-slide\" data-room-id=\"" + item.id + "\">" + _preview2 + preloader + "</div>");
                        }
                    }
                }
            }, {
                key: "_renderSwiper",
                value: function _renderSwiper(type) {
                    var swiper = this._createSwiper(type);
                    var controls = type === 'main' ? this._createControls(type) : '';
                    var pagination = type === 'main' ? '<div class="swiper-pagination"></div>' : '';
                    var photos = type === 'main' ? this.photos.join('') : this.previews.join('');

                    swiper.innerHTML = "<div class=\"swiper-wrapper\">" + photos + "</div>" + pagination + controls;

                    return swiper;
                }
            }, {
                key: "_createSwiper",
                value: function _createSwiper(type) {
                    var content = document.createElement('div');

                    content.id = type === 'main' ? 'hotelPhotosMainSlider' : 'hotelPhotosThumbsSlider';
                    content.classList.add('swiper');

                    return content;
                }
            }, {
                key: "_createControls",
                value: function _createControls(type) {
                    var btnPrev = "<button class=\"" + type + "-swiper-control " + type + "-swiper-control-prev\"></button>";
                    var btnNext = "<button class=\"" + type + "-swiper-control " + type + "-swiper-control-next\"></button>";

                    return "" + btnPrev + btnNext;
                }
            }, {
                key: "initSwiper",
                value: function initSwiper() {
                    var isFirst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    var self = this;

                    this.thumbsSwiper = new Swiper('#hotelPhotosThumbsSlider', {
                        preloadImages: false,
                        lazy: {
                            loadPrevNext: true, // грузить соседние
                            loadPrevNextAmount: 1,
                            loadOnTransitionStart: true
                        },
                        watchSlidesProgress: true, // важно для lazy + 'auto'
                        observer: true,
                        observeParents: true,
                        loop: false,
                        spaceBetween: 10,
                        slidesPerView: 8.5,
                        freeMode: false,
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        },
                        on: {
                            slideChange: function slideChange(swiper) {
                                self.ensureImages(swiper, 8);
                            }
                        }
                    });

                    var params = {
                        preloadImages: false,
                        lazy: {
                            loadPrevNext: true, // грузить соседние
                            loadPrevNextAmount: 1,
                            loadOnTransitionStart: true
                        },
                        watchSlidesProgress: true, // важно для lazy + 'auto'
                        observer: true,
                        observeParents: true,
                        loop: false,
                        spaceBetween: 0,
                        pagination: {
                            el: ".swiper-pagination",
                            type: "fraction"
                        },
                        navigation: {
                            nextEl: '.main-swiper-control-next',
                            prevEl: '.main-swiper-control-prev'
                        },
                        thumbs: {
                            swiper: this.thumbsSwiper
                        },
                        on: {
                            slideChange: function slideChange(swiper) {
                                self.ensureImages(swiper, 1);
                            }
                        }
                    };

                    this.mainSwiper = new Swiper('#hotelPhotosMainSlider', params);
                    this._bindMainEdgeNav();

                    if (isFirst) {
                        this.handlers();
                    }
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this3 = this;

                    eventDispatcher.addEventListener('set-active-slide', function (params) {
                        _this3.mainSwiper.slideTo(+params.index, 0);
                        _this3.thumbsSwiper.slideTo(+params.index, 0);
                    });

                    eventDispatcher.addEventListener('filter-slides', function (params) {
                        var categoryId = String(params.categoryId);
                        var filteredMainSwiperSlides = void 0,
                            filteredThumbsSwiperSlides = void 0;

                        if (categoryId === '0') {
                            filteredMainSwiperSlides = _this3.photos;
                            filteredThumbsSwiperSlides = _this3.previews;
                        } else {
                            filteredMainSwiperSlides = _this3._filterSlides('main', categoryId);
                            filteredThumbsSwiperSlides = _this3._filterSlides('preview', categoryId);
                        }

                        _this3._buildSwipers(filteredMainSwiperSlides, filteredThumbsSwiperSlides);
                    });

                    eventDispatcher.addEventListener('filter-rooms', function (params) {
                        var categoryId = String(params.categoryId);
                        var roomId = String(params.roomId);

                        var filteredMainSwiperSlides = void 0,
                            filteredThumbsSwiperSlides = void 0;

                        if (roomId === '0') {
                            filteredMainSwiperSlides = _this3._filterSlides('main', categoryId);
                            filteredThumbsSwiperSlides = _this3._filterSlides('preview', categoryId);
                        } else {
                            filteredMainSwiperSlides = _this3._filterRoomSlides('main', roomId);
                            filteredThumbsSwiperSlides = _this3._filterRoomSlides('preview', roomId);
                        }

                        _this3._buildSwipers(filteredMainSwiperSlides, filteredThumbsSwiperSlides);
                    });
                }
            }, {
                key: "_filterSlides",
                value: function _filterSlides(type, categoryId) {
                    var photos = type === 'main' ? this.photos : this.previews;

                    return photos.filter(function (slide) {
                        var match = slide.match(/data-category="([^"]+)"/);
                        return match && match[1] === categoryId;
                    });
                }
            }, {
                key: "_filterRoomSlides",
                value: function _filterRoomSlides(type, roomId) {
                    var photos = type === 'main' ? this.roomSlides : this.roomPreviewSlides;

                    return photos.filter(function (slide) {
                        var match = slide.match(/data-room-id="([^"]+)"/);
                        return match && match[1] === roomId;
                    });
                }
            }, {
                key: "_buildSwipers",
                value: function _buildSwipers(main, thumbs) {
                    if (this.mainSwiper) this.mainSwiper.destroy(true, true);
                    if (this.thumbsSwiper) this.thumbsSwiper.destroy(true, true);

                    QS('#hotelPhotosThumbsSlider .swiper-wrapper').innerHTML = '';
                    QS('#hotelPhotosMainSlider .swiper-wrapper').innerHTML = '';

                    this.initSwiper(false);

                    this.thumbsSwiper.appendSlide(thumbs);
                    this.thumbsSwiper.update();
                    this.thumbsSwiper.slideTo(0, 0);

                    this.mainSwiper.appendSlide(main);
                    this.mainSwiper.update();
                    this.mainSwiper.slideTo(0, 0);

                    this.ensureImages(this.mainSwiper, 1);
                    this.ensureImages(this.thumbsSwiper, 8);
                }
            }, {
                key: "ensureImages",
                value: function ensureImages(swiper) {
                    var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

                    var active = swiper.activeIndex;
                    var from = Math.max(0, active - radius);
                    var to = Math.min(swiper.slides.length - 1, active + radius);

                    for (var i = from; i <= to; i++) {
                        var slide = swiper.slides[i];
                        if (!slide) continue;

                        var img = slide.querySelector('img[data-src]');
                        if (!img) continue;

                        var src = img.getAttribute('data-src');
                        if (!src) continue;

                        img.src = src; // ← запрос появится только тут
                        img.removeAttribute('data-src');
                        img.decoding = 'async';
                        img.loading = i === active ? 'eager' : 'lazy';
                    }
                }
            }, {
                key: "_bindMainEdgeNav",
                value: function _bindMainEdgeNav() {
                    var _this4 = this;

                    var el = QS('#hotelPhotosMainSlider');
                    if (!el) return;

                    if (this._mainEdgeClickHandler) {
                        el.removeEventListener('click', this._mainEdgeClickHandler);
                    }

                    this._mainEdgeClickHandler = function (e) {
                        if (!_this4.mainSwiper) return;

                        if (e.target.closest('.main-swiper-control') || e.target.closest('.swiper-pagination')) {
                            return;
                        }

                        var rect = el.getBoundingClientRect();
                        var x = e.clientX - rect.left;
                        var edgeWidth = rect.width * 0.2;

                        if (x <= edgeWidth) {
                            _this4.mainSwiper.slidePrev();
                        } else if (x >= rect.width - edgeWidth) {
                            _this4.mainSwiper.slideNext();
                        }
                    };

                    el.addEventListener('click', this._mainEdgeClickHandler, { passive: true });
                }
            }]);

            return MainSlider;
        }();

        window.HotelImageGalleryMainSlider = MainSlider;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var _window = window,
            HotelImageGalleyCategories = _window.HotelImageGalleyCategories,
            HotelImageGalleryMainSlider = _window.HotelImageGalleryMainSlider;

        var HotelPhotoGalleryDesktop = function () {
            function HotelPhotoGalleryDesktop(params) {
                _classCallCheck(this, HotelPhotoGalleryDesktop);

                this.modal = window.modal;
                this.photos = params.photos ? params.photos : null;
                this.pageType = params.pageType ? params.pageType : null;

                this.photoStore = window.HotelReviewPhotos.get(params.hotelId, params.photosUrl);
                this.touristPhotosLabel = params.touristPhotosLabel;
                this.isFirstOpenModal = true;

                this.components = {};
                this.tailIndex = null;

                this.init();

                this.handlers();
            }

            _createClass(HotelPhotoGalleryDesktop, [{
                key: "init",
                value: function init() {
                    if (!this.photos) {
                        return;
                    }

                    this.components = {
                        ImageCategories: new HotelImageGalleyCategories({
                            images: this.photos.categories,
                            rooms: this.photos.roomCategories,
                            pageType: this.pageType
                        }),
                        MainSlider: new HotelImageGalleryMainSlider({
                            photosByCategories: this.photos.photosByCategories,
                            reviewsPhotos: this.photos.reviewsPhotos,
                            roomsPhotos: this.photos.roomsPhotos,
                            pageType: this.pageType
                        })
                    };
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this5 = this;

                    eventDispatcher.on('click', '.show-gallery', function (event, target) {
                        _this5.tailIndex = target.dataset.index;

                        if (_this5.isFirstOpenModal) {
                            _this5.renderDetachContent();
                            _this5.openModal();
                            _this5.isFirstOpenModal = false;
                        } else {
                            _this5.openModal();
                        }

                        var eventProperties = { Page: _this5.pageType };
                        window.brxTracking.sendAnalyticsEvent('click_hotel_photo_slider', eventProperties);

                        eventDispatcher.dispatchEvent('set-active-slide', {
                            index: _this5.tailIndex
                        });
                    });
                }
            }, {
                key: "openModal",
                value: function openModal() {
                    var _this6 = this;

                    if (!this.modal || typeof this.modal.open !== 'function') return;

                    this.modal.open({
                        header: { title: '' },
                        content: { htmlDetachSelectorId: 'hotelPhotosModal' },
                        parentCssClass: 'hotel-photos-modal',
                        footer: null,
                        type: 'floating',
                        onAfterShow: function onAfterShow() {
                            _this6.loadTouristPhotos();
                        },
                        onBeforeClose: function onBeforeClose() {
                            _this6.tailIndex = null;

                            QS('#hotelPhotosCategories .category-item[data-id="0"]').click();
                        }
                    });
                }
            }, {
                key: "loadTouristPhotos",
                value: function loadTouristPhotos() {
                    var _this7 = this;

                    return this.photoStore.load().then(function (photos) {
                        _this7.components.MainSlider.setReviewPhotos(photos);
                        _this7.components.ImageCategories.setReviewPhotos(photos, _this7.touristPhotosLabel);
                        return photos;
                    }).catch(function () {
                        return [];
                    });
                }
            }, {
                key: "openTouristPhotos",
                value: function openTouristPhotos(index) {
                    var _this8 = this;

                    if (this.isFirstOpenModal) {
                        this.renderDetachContent();
                        this.isFirstOpenModal = false;
                    }
                    this.openModal();
                    this.loadTouristPhotos().then(function (photos) {
                        if (!photos.length) return;
                        var category = QS('#hotelPhotosCategories .category-item[data-id="34"]');
                        if (category && !category.classList.contains('active')) category.click();
                        _this8.components.MainSlider.mainSwiper.slideTo(index, 0);
                        _this8.components.MainSlider.thumbsSwiper.slideTo(index, 0);
                        _this8.components.MainSlider.ensureImages(_this8.components.MainSlider.mainSwiper, 1);
                    });
                }
            }, {
                key: "closeModal",
                value: function closeModal() {
                    this.modal.close('.modal2');
                    this.tailIndex = null;
                }
            }, {
                key: "renderDetachContent",
                value: function renderDetachContent() {
                    document.body.appendChild(this._createHiddenWrapper());

                    this.components.ImageCategories.initSwiper();
                    this.components.MainSlider.initSwiper();
                }
            }, {
                key: "_createHiddenWrapper",
                value: function _createHiddenWrapper() {
                    var hiddenWrapper = document.createElement('div');
                    hiddenWrapper.classList.add('hide');

                    hiddenWrapper.appendChild(this._createModalContent());

                    return hiddenWrapper;
                }
            }, {
                key: "_createModalContent",
                value: function _createModalContent() {
                    var content = document.createElement('div');
                    content.id = 'hotelPhotosModal';

                    content.appendChild(this.components.ImageCategories.renderCategories());
                    content.appendChild(this.components.MainSlider.render());

                    return content;
                }
            }]);

            return HotelPhotoGalleryDesktop;
        }();

        window.HotelPhotoGalleryDesktop = HotelPhotoGalleryDesktop;
    }, {}] }, {}, [1]);